class FtaCartRecommendations extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    if (!productId) return;
    this.addEventListener('click', (event) => this.addRecommendedProduct(event));
    this.loadRecommendations(productId);
  }

  async loadRecommendations(productId) {
    const root = window.Shopify?.routes?.root || '/';
    for (const intent of ['complementary', 'related']) {
      try {
        const url = new URL(`${root}recommendations/products`, window.location.origin);
        url.searchParams.set('section_id', 'fta-cart-recommendations');
        url.searchParams.set('product_id', productId);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', intent);
        const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
        const response = await fetch(url);
        if (!response.ok) continue;
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || this.dataset.productId !== productId) return;
        const rail = documentFragment.querySelector('.fta-cart-recommendations');
        if (!rail?.querySelector('.fta-cart-recommendations__item')) continue;
        this.replaceChildren(rail);
        this.hidden = false;
        return;
      } catch {
        continue;
      }
    }
  }

  async addRecommendedProduct(event) {
    const button = event.target.closest('button[data-variant-id]');
    if (!button || !this.contains(button) || button.disabled) return;
    button.disabled = true;
    const oldLabel = button.textContent;
    button.textContent = 'Adding…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname + window.location.search,
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || !result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) {
        window.location.assign(`${root}cart`);
        return;
      }
      drawer.renderContents(result);
    } catch (error) {
      if (!this.isConnected) return;
      button.disabled = false;
      button.textContent = oldLabel;
      const status = this.querySelector('[role="status"]');
      if (status) status.textContent = error.message || 'Unable to add this item.';
    }
  }
}

if (!customElements.get('fta-cart-recommendations')) {
  customElements.define('fta-cart-recommendations', FtaCartRecommendations);
}
